import React from 'react';
import DetailsCard from '../../subscription/details/components/DetailsCard';
import { referralStatus, formatReferralDate } from '../referralStatus';
import styles from '../Referral.module.css';

const PILL_CLASS = {
  neutral: styles.pillNeutral,
  info: styles.pillInfo,
  success: styles.pillSuccess,
};

/**
 * Contagens e a lista de quem a conta indicou.
 * @param {Object} props
 * @param {{ invited: number, signed_up: number, subscribed: number, rewarded: number }} props.counts
 * @param {Array<{ name: string, date: string, status: string }>} props.referrals
 * @param {number} [props.waitingCredits] créditos guardados à espera de a conta assinar
 */
function ReferralListCard({ counts, referrals, waitingCredits = 0 }) {
  const invited = (counts?.invited || 0) + (counts?.signed_up || 0) + (counts?.subscribed || 0) + (counts?.rewarded || 0);
  const subscribed = (counts?.subscribed || 0) + (counts?.rewarded || 0);

  return (
    <DetailsCard title="Suas indicações">
      <div className={styles.counts}>
        <div className={styles.count}>
          <span className={styles.countValue}>{invited}</span>
          <span className={styles.countLabel}>indicadas</span>
        </div>
        <div className={styles.count}>
          <span className={styles.countValue}>{subscribed}</span>
          <span className={styles.countLabel}>assinaram</span>
        </div>
        <div className={styles.count}>
          <span className={styles.countValue}>{counts?.rewarded || 0}</span>
          <span className={styles.countLabel}>créditos ganhos</span>
        </div>
      </div>

      {waitingCredits > 0 && (
        <p className={styles.rule}>
          {waitingCredits === 1 ? 'Você tem um crédito guardado' : `Você tem ${waitingCredits} créditos guardados`}: ele
          {waitingCredits === 1 ? ' entra' : 's entram'} na sua fatura assim que você assinar.
        </p>
      )}

      {referrals.length === 0 ? (
        <p className={styles.empty}>Ninguém ainda. Sua primeira indicação aparece aqui.</p>
      ) : (
        <ul className={styles.list}>
          {referrals.map((item, index) => {
            const status = referralStatus(item.status);
            return (
              <li key={`${item.status}-${index}`} className={styles.item}>
                <span className={styles.itemName}>
                  {item.name}
                  <span className={styles.itemDate}>{formatReferralDate(item.date)}</span>
                </span>
                <span className={`${styles.pill} ${PILL_CLASS[status.tone] || styles.pillNeutral}`}>{status.label}</span>
              </li>
            );
          })}
        </ul>
      )}
    </DetailsCard>
  );
}

export default ReferralListCard;
